import api from "../../utils/ApiConfig";

export const fetchRoiSettings = async () => {
  const response = await api.get("/bo/pricing-settings");
  const all = response.data.settings ?? {};
  return { settings: { roi: all.roi ?? [] } };
};

export const bulkUpdateRoiSettings = async (settings) => {
  const response = await api.put("/bo/pricing-settings/bulk", { settings });
  return response.data;
};
